import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../store';

export const selectAppDetails = (state: RootState) => state.appDetails;

export const selectIsReferralCostco = createSelector(selectAppDetails, ({ groups }) =>
  groups.includes('costco')
);

export const selectIsReferralVelocity = createSelector(selectAppDetails, ({ groups }) =>
  groups.includes('velocity')
);

export const selectHasMultipleReferrals = createSelector(
  selectAppDetails,
  ({ groups }) => groups.filter((group) => group !== 'staff').length > 1
);

export const selectIsReferral = createSelector(
  selectAppDetails,
  ({ groups }) => groups.length > 0 && groups.some((group) => group !== 'staff')
);

export const selectIsStaff = createSelector(selectAppDetails, ({ groups }) =>
  groups.includes('staff')
);

export const selectSpaId = createSelector(selectAppDetails, ({ spaId }) => spaId);
